var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 11",
    filter: "url(#filter0_d_938_286)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 24.5,
    stroke: "#FF965A",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 81",
    d: "M14.265 27.3638H33.9735L27.2734 34.0513C26.7777 34.5471 26.7777 35.3508 27.2734 35.8465C27.7691 36.3422 28.5728 36.3422 29.0685 35.8465L37.9178 26.9972C38.0294 26.8743 38.1192 26.7332 38.1832 26.58C38.3185 26.2741 38.3185 25.9253 38.1832 25.6193C38.1192 25.4661 38.0294 25.325 37.9178 25.2021L29.0685 16.3528C28.8311 16.1135 28.508 15.9789 28.1709 15.9789C27.8339 15.9789 27.5107 16.1135 27.2734 16.3528C27.0341 16.5902 26.8994 16.9133 26.8994 17.2504C26.8994 17.5875 27.0341 17.9106 27.2734 18.148L33.9735 24.8355H14.265C13.5668 24.8355 13.0008 25.4015 13.0008 26.0997C13.0008 26.7978 13.5668 27.3638 14.265 27.3638Z",
    fill: "#FF965A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_938_286",
    x: 0,
    y: 0,
    width: 81.5,
    height: 81.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 18,
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0901961 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_938_286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_938_286",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c56ca861adf3dcf01515e7c51d7065c4.svg";
export { ForwardRef as ReactComponent };